import { mutate } from 'swr/_internal';
import { loadedKeys } from './utils/middleware/loadOnce';
import { deleteCookie, ls } from './utils/utils';

export const signOut = (e: React.MouseEvent) => {
  e.preventDefault();
  ls.remove('current-wiki-id');
  loadedKeys.clear();
  void mutate(() => true, undefined, { revalidate: false });
  deleteCookie('wikiId');
  gapi.client.setToken(null as never);
  void fetch('/api/user/signout');
  history.pushState(null, '', '/login');
};
